// import { isSecondaryHospital } from '@/utils'

/*
 * @Description:
 * @Version:
 * @Autor: baichenhui
 * @Date: 2021-08-25 11:37:19
 */
function apiUrlHeader () {
  if (process.env.NODE_ENV === 'development') {
    // return `//${location.hostname}`
    // return 'https://hyhis-longdu-web.yikangbao.com.cn'
    // return 'http://10.109.51.98:9080'
    // return 'https://hyhis-dev.yikangbao.com.cn'
    // return 'https://hyhis-lingdong-web.yikangbao.com.cn/'
    // return '//chaoyangrunsheng.yikangbao.com.cn'
    // return 'https://hyhis-lianxia-web.yikangbao.com.cn'
    // return 'https://hyhis-bainade-web.yikangbao.com.cn/'
    // return 'https://cloud-clinic-dexin.yikangbao.com.cn/'
    // return 'http://10.109.51.95:9080'
    // return 'http://192.168.1.81:38081'
    return '/'
  }
  // return isSecondaryHospital() ? `//${location.host}` : `//${location.hostname}`
  return process.env.API_URL || `//${location.host}`
}

function setWindowStore (at) {
  window.g_public_rsa_key = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsqhcE4HaqdEOVSMUPbvFxQMN0HvYezgFbnEMzXBcgQ7dBzXp1GV5ZWEELzbIrQsBCwxLygzArparzF2HT8RxRiSCJIvQUBX/eBeucfozZJ1HW8uE/AC1N9O2A8Zdu1VXDgHVKgJ8Rtgoq2+k6AP9XQo2h7vYtlKezCX6Yso9zbYRpArmhuUt0fhxDkbbVYThOX+49tadm+n6rTpt3094ND9p1d76mB+35WIlCbYtm22QCrGG75VgPFNCZ6emjM3hWS2mXSXBi7+rr/WsPhRv3WBCnJlUHa4ldFZJed8vNOPxLUCehWg50XGW0QqqVpf/RX1weJcv+IDK6JdYOGAYFQIDAQAB'
  window.store = {
    // host: 'https://hyhis-lingdong-api.yikangbao.com.cn/',
    host: apiUrlHeader(),
    access_token: at ||
    '5b5387cb-cf81-46b6-9a73-13df1a15008d'
  }
}

export { apiUrlHeader, setWindowStore }
